export interface UserApiResource {
  id: string;
  email: string;
  pending_email: string | null;
  full_name: string;
  phone: string | null;
  profile_picture_url: string | null;
  preferred_language: string;
  is_active: boolean;
  is_email_verified: boolean;
  created_at: string;
  updated_at: string;
}

export interface PlatformUser {
  id: string;
  email: string;
  pendingEmail: string | null;
  fullName: string;
  phone: string | null;
  profilePictureUrl: string | null;
  preferredLanguage: string;
  isActive: boolean;
  isEmailVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CurrentAccessApiResource {
  platform_permissions: string[];
}

export interface UpdateCurrentUserProfileInput {
  fullName?: string;
  phone?: string | null;
  preferredLanguage?: string;
}

export function mapApiResourceToUser(resource: UserApiResource): PlatformUser {
  return {
    id: resource.id,
    email: resource.email,
    pendingEmail: resource.pending_email,
    fullName: resource.full_name,
    phone: resource.phone,
    profilePictureUrl: resource.profile_picture_url,
    preferredLanguage: resource.preferred_language,
    isActive: resource.is_active,
    isEmailVerified: resource.is_email_verified,
    createdAt: resource.created_at,
    updatedAt: resource.updated_at,
  };
}
